import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ParkingManagerService } from '@core/services/parking-manager.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-deactivate-modal',
  templateUrl: './deactivate-modal.component.html',
  styleUrls: ['./deactivate-modal.component.scss']
})
export class DeactivateModalComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  id :string='';
  status
  isDeactivate:boolean = true;
  isActivate:boolean = false;
  constructor(public readonly ref: DynamicDialogRef, public readonly config: DynamicDialogConfig,private readonly service:ParkingManagerService) { }

  ngOnInit(): void {
    this.id = this.config.data.bodyText.id;
    this.status=this.config.data.bodyText.isActive;
    if(this.status==false){
     this.isDeactivate=false;
      this.isActivate=true
    }
  }

  continue(): void {
    const req= {
     id:this.id
    }  
      this.service.activateOrDeactivateManagerId(req)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
      next: (_response: any) => {
        this.ref.close();
      }
    })  }
  cancel():void{
    this.ref.close('cancel');
  }
}
